<div class="img">
    <header>
        <app-barra></app-barra>
    </header>
    <aside class="container-fluid">
      <div>
          <router-outlet ></router-outlet>
      </div>
    </aside>
    <footer>
        <app-footer></app-footer>
    </footer>
</div>




